// extracted by mini-css-extract-plugin
export default {"title":"other_work_projects_title__YHDRA","grid-view":"other_work_projects_grid-view__mj-h7"};